<template>
    <b-row>
        <b-col md="6">
            <b-form-group label="Provinsi Cabang">
                <multiselect
                    name="provinsiCabang"
                    :value="value.provinsi"
                    :options="opsi.provinsi"
                    :loading="loading.provinsi"
                    :allow-empty="false"
                    deselect-label=""
                    select-label=""
                    label="name"
                    track-by="id"
                    placeholder="Pilih provinsi"
                    @input="pilihProvinsi"
                />
            </b-form-group>
        </b-col>

        <b-col md="6">
            <b-form-group label="Kota Cabang">
                <multiselect
                    name="kotaCabang"
                    :value="value.kota"
                    :options="opsi.kota"
                    :loading="loading.kota"
                    :disabled="!value.provinsi"
                    :allow-empty="false"
                    deselect-label=""
                    select-label=""
                    label="name"
                    track-by="id"
                    :placeholder="value.provinsi ? 'Pilih kota' : 'Pilih provinsi dulu'"
                    @input="pilihKota"
                />
            </b-form-group>
        </b-col>

        <b-col md="6">
            <b-form-group label="Kecamatan Cabang">
                <multiselect
                    name="kecamatanCabang"
                    :value="value.kecamatan"
                    :options="opsi.kecamatan"
                    :loading="loading.kecamatan"
                    :disabled="!value.kota"
                    :allow-empty="false"
                    deselect-label=""
                    select-label=""
                    label="name"
                    track-by="id"
                    :placeholder="value.kota ? 'Pilih kecamatan' : 'Pilih kota dulu'"
                    @input="pilihKecamatan"
                />
            </b-form-group>
        </b-col>

        <b-col md="6">
            <b-form-group label="Kelurahan Cabang">
                <multiselect
                    name="kelurahanCabang"
                    :value="value.kelurahan"
                    :options="opsi.kelurahan"
                    :loading="loading.kelurahan"
                    :disabled="!value.kecamatan"
                    :allow-empty="false"
                    deselect-label=""
                    select-label=""
                    label="name"
                    track-by="id"
                    :placeholder="value.kecamatan ? 'Pilih kelurahan' : 'Pilih kecamatan dulu'"
                    @input="pilihKelurahan"
                />
            </b-form-group>
        </b-col>
    </b-row>
</template>

<script>
// Lokasi cabang berjenjang Provinsi > Kota > Kecamatan > Kelurahan.
// Lokasi ini dipakai backend untuk menentukan wilayah kerja (master parameter) yang berlaku bagi cabang.
// v-model: { provinsi, kota, kecamatan, kelurahan }, masing-masing { id, name } atau null.
export default {
    name: 'LokasiCabang',
    props: {
        value: { type: Object, required: true }
    },
    data() {
        return {
            opsi: { provinsi: [], kota: [], kecamatan: [], kelurahan: [] },
            loading: { provinsi: false, kota: false, kecamatan: false, kelurahan: false }
        }
    },
    methods: {
        muat(tingkat, url) {
            this.loading[tingkat] = true
            return this.$axios.get(url).then(response => {
                this.opsi[tingkat] = response.data
            })
            .catch(error => {
                console.log(error)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.loading[tingkat] = false
            })
        },

        ubah(perubahan) {
            this.$emit('input', Object.assign({}, this.value, perubahan))
        },

        // Mengganti tingkat atas mengosongkan tingkat di bawahnya
        pilihProvinsi(provinsi) {
            this.ubah({ provinsi, kota: null, kecamatan: null, kelurahan: null })
            this.opsi.kota = []
            this.opsi.kecamatan = []
            this.opsi.kelurahan = []
            this.muat('kota', `area/kota/${provinsi.id}`)
        },

        pilihKota(kota) {
            this.ubah({ kota, kecamatan: null, kelurahan: null })
            this.opsi.kecamatan = []
            this.opsi.kelurahan = []
            this.muat('kecamatan', `area/kecamatan/${kota.id}`)
        },

        pilihKecamatan(kecamatan) {
            this.ubah({ kecamatan, kelurahan: null })
            this.opsi.kelurahan = []
            this.muat('kelurahan', `area/kelurahan/${kecamatan.id}`)
        },

        pilihKelurahan(kelurahan) {
            this.ubah({ kelurahan })
        }
    },
    created() {
        // Saat edit, muat pilihan setiap tingkat yang sudah terisi
        this.muat('provinsi', 'area/provinsi/')
        if (this.value.provinsi) this.muat('kota', `area/kota/${this.value.provinsi.id}`)
        if (this.value.kota) this.muat('kecamatan', `area/kecamatan/${this.value.kota.id}`)
        if (this.value.kecamatan) this.muat('kelurahan', `area/kelurahan/${this.value.kecamatan.id}`)
    }
}
</script>
